module.exports = __webpack_public_path__ + "static/img/book30.c1ea9a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book30.jpg
// module id = OIr+
// module chunks = 1